'use client';

import classNames from '@sindresorhus/class-names';
import Image from 'next/image';
import {useState} from 'react';
import {createPortal} from 'react-dom';

import Calendar from '@web-catalog/assets/icons/calendar.svg';
import CloseIcon from '@web-catalog/assets/icons/cancel_outline_28.svg';

import {RecommendedApp} from '@web-catalog/types';

import useMediaQueryMatch from '@web-catalog/hooks/useMediaQueryMatch';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics';

import styles from './PreorderLink.module.scss';

type Props = {
  isEnablePreorderRedesign?: boolean;
  featuringId: string;
  placement: 'mainPage' | 'monoFeaturing';
} & RecommendedApp;

export const PreorderLink = ({
  featuringId,
  appName,
  packageName,
  shortDescription,
  isEnablePreorderRedesign,
  iconUrl,
  placement,
}: Props) => {
  const searchParams = new URLSearchParams({
    appName: appName,
    utm_campaign: packageName,
    type: 'featuring',
    featuringId,
  });
  const [isModalVisible, setModalVisible] = useState(false);
  const isMobile = useMediaQueryMatch('(max-width: 720px)');

  const url = `/instruction?${searchParams.toString()}`;

  const onClick = () => {
    logTmrEvent({
      logEvent: 'button.click',
      params: {
        button_text: 'Предзаказ',
        app_id: packageName,
      },
    });
    emitYmEvent({eventName: 'button_click_preorder'});
  };

  const onModalPreorderClick = () => {
    if (isMobile) {
      onClick();
      window.location.assign(`rustore://featuring/${featuringId}`);
      setTimeout(() => {
        window.location.assign(url);
      }, 50);
    }
  };
  const onOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget && isModalVisible) {
      onChangeModalState();
    }
  };
  const onChangeModalState = () => {
    if (isMobile) {
      setModalVisible((state) => !state);
    }
  };

  if (isEnablePreorderRedesign)
    return (
      <>
        {isModalVisible &&
          isMobile &&
          createPortal(
            <div className={styles.modal} onClick={onOverlayClick}>
              <div
                className={styles.modal__content}
                data-testid="preorder__modal"
              >
                <span
                  className={styles.modal__content_closeIcon}
                  onClick={onChangeModalState}
                >
                  <CloseIcon />
                </span>
                <span className={styles.modal__content_icon}>
                  <Calendar />
                </span>
                <span className={styles.modal__content_title}>
                  Чтобы оформить предзаказ,
                  <br /> скачайте&nbsp;RuStore
                </span>
                <button
                  className={styles.modal__content_button}
                  onClick={onModalPreorderClick}
                  data-testid="preorder__modal_button"
                >
                  Оформить предзаказ
                </button>
              </div>
            </div>,
            document.body,
          )}
        <div
          className={classNames(styles.preorderRedesign, styles[placement])}
          data-testid="preorder__app"
          onClick={onChangeModalState}
        >
          <div className={styles.preorderRedesign__app}>
            <div className={styles.icon}>
              <Image src={iconUrl} alt={appName} fill />
            </div>

            <div>
              <div className={styles.appName}>{appName}</div>
              <p className={styles.appDescription}>{shortDescription}</p>
              <button className={styles.preorderRedesign__app_button}>
                Предзаказ
              </button>
            </div>
            <div
              className={styles.preorderRedesign__app_tooltipWrapper}
              data-testid="preorder__tooltip"
            >
              <div className={styles.preorderRedesign__app_tooltip}>
                Чтобы оформить предзаказ,&nbsp;
                <a href="/instruction">скачайте&nbsp;RuStore</a>
              </div>
            </div>
          </div>
        </div>
      </>
    );

  return (
    <div className={styles.preorder}>
      <div className={styles.preorder__header}>
        Чтобы оформить предзаказ, <a href={url}>скачайте&nbsp;RuStore</a>
      </div>

      <div className={styles.preorder__app}>
        <div className={styles.icon}>
          <Image src={iconUrl} alt={appName} fill />
        </div>

        <div>
          <div className={styles.appName}>{appName}</div>
          <p className={styles.appDescription}>{shortDescription}</p>
        </div>
        <a onClick={onClick} className={styles.preorder__app_button} href={url}>
          Предзаказ
        </a>
      </div>
    </div>
  );
};
